import { FC, useEffect } from 'react';
import { UserInfo } from './user-info';
import { ContentTabs } from './content-tabs';
import { useAtomValue, useSetAtom } from 'jotai';
import { $CurrentUser } from '@user/shared/current-user';
import { UserDetailUtil } from 'shared/models';
import { NotFound } from '~/components/not-found';
import { UserSilentAwaken, UserSilentAwakenV2 } from './user-silent-awaken';
import { $LandingModalState } from '~/components/landing-modal/atom';
import { LandingModal } from '~/components/landing-modal';
import { $LibraOptimizeSilentAwaken } from '~/utils/libra/streaming';

const UserAvailableBody: FC = () => {
  const setLandingModalState = useSetAtom($LandingModalState);
  const optimizeSilentAwaken = useAtomValue($LibraOptimizeSilentAwaken);

  useEffect(() => {
    setLandingModalState({ open: true, hasClosed: false });
  }, []);

  return (
    <>
      {optimizeSilentAwaken ? <UserSilentAwakenV2 /> : <UserSilentAwaken />}
      <LandingModal />
      <UserInfo />
      <ContentTabs />
    </>
  );
};

export const UserBody: FC = () => {
  const user = useAtomValue($CurrentUser);

  if (UserDetailUtil.isUserAvailable(user)) {
    return <UserAvailableBody />;
  }

  return (
    <>
      <LandingModal />
      <NotFound />
    </>
  );
};
